import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { navigationPaths, routerPaths } from "../../constants/paths"
import api from "../../utilities/api"
import { isFMCUser, isFMC } from "../../helpers/userRoleHelpers"
import { Redirect } from "react-router"

import Alert, { ALERT_MESSAGE } from "../../components/shared/Alert"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import FleetList from "../../components/dashboard/FleetList"
import Stats from "../../components/fleets/Stats"
import LoadingError from "../../components/shared/LoadingError"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import { Button, Container, Header, Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { isFleetAdvise, isMobilease } from "../../helpers/affiliationHelpers"
import { logFirebaseAnalyticsScreenName } from "../../helpers/googleAnalyticsHelpers"
import { getRouteNameFromUrl } from "../../helpers/segmentHelpers"
import { checkSubDomain } from "../../constants/downloadApp"
import DownloadAppModal from "./DownloadAppModal"
import { clearStateAfterTimeout } from "../../helpers/documentHelpers"
import DownloadIcon from "../../assets/images/DownloadIcon.png"
import CustomButton from "../../components/shared/CustomButton"

class FMCDashboard extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoadingError: PropTypes.bool.isRequired,
    fleets: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)

    const locationStateData = this.props.location.state || {}

    this.state = {
      alertMessage: locationStateData.alertMessage || "",
      alertType: locationStateData.alertType || "default",
      filterData: this.initialFilterData(),
      page: 1,
      showInactiveFleets: false
    }
  }

  componentDidMount() {
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())
    const { filterType, filterValue } = this.state.filterData
    const { dispatch, currentUser, fleets } = this.props
    if (currentUser) {
      dispatch({
        type: "FLEETS_LOAD_SAGA",
        payload: {
          filter: {
            filterType: filterType,
            filterValue: filterValue
          },
          page: 1
        }
      })
    }
  }

  initialFilterData() {
    let filterData = {
      filterType: "all",
      filterValue: ""
    }

    const queryString = window.location.search

    if (queryString !== "") {
      filterData["filterType"] = queryString.split("=")[0].replace("?", "")
      filterData["filterValue"] = queryString.split("=")[1].replace("%20", " ")
    }

    return filterData
  }

  onFilterChange(field, value) {
    let updatedFilterData = { ...this.state.filterData }
    updatedFilterData[field] = value

    // NOTE: Resets text field on type select change.
    if (field === "filterType") {
      updatedFilterData["filterValue"] = ""
    }

    this.setState({ filterData: updatedFilterData })
  }

  onFilterSubmit() {
    const { filterType, filterValue } = this.state.filterData

    this.props.dispatch({
      type: "FLEETS_LOAD_SAGA",
      payload: {
        filter: {
          filterType: filterType,
          filterValue: filterValue
        },
        pageLoad: "false"
      }
    })

    this.updateQueryParams()
  }

  shouldRenderContent() {
    const { isLoading, fleetsLoading, isLoadingError, fleets, currentUser } = this.props

    return (
      !isLoading &&
      !fleetsLoading &&
      !isLoadingError &&
      fleets &&
      currentUser &&
      isFMCUser(currentUser)
    )
  }

  updateQueryParams() {
    const { filterType, filterValue } = this.state.filterData

    let updatedUrl = "/"

    if (filterType !== "all") {
      updatedUrl = `/?${filterType}=${filterValue}`
    }

    window.history.replaceState({}, "", updatedUrl)
  }

  handlePage = (page) => {
    this.setState({ page: page })
  }

  handleCheckboxChange = (e, data) => {
    this.setState({
      showInactiveFleets: data.checked
    })
  }

  renderContent() {
    const { fleets, currentUser, t, dispatch, fleetsLoading, totalFleetCount } = this.props
    const { authentication_token } = currentUser
    const { page } = this.state

    if (currentUser && !isFMCUser(currentUser)) {
      // TODO: extract this work to the Router itself.
      return <Redirect to={routerPaths.dashboard} />
    } else {
      return (
        <div>
          <span />
          <Header size="small" className={"dash-hd"}>
            {t("fleetsLabel")}
          </Header>
          <Stats
            fleets={fleets}
            currentUser={currentUser}
            dispatch={dispatch}
            showInactiveFleets={this.state.showInactiveFleets}
          />
          <Container textAlign="right" fluid>
            {isFMC(currentUser) ? (
              <Button
                icon="plus"
                content={t("addNewFleetLabel")}
                onClick={() => this.props.history.push(navigationPaths.fleetNew())}
                primary
                className={`${
                  isFleetAdvise() || isMobilease() ? "reset-filters-btn btn-margin-right" : ""
                }`}
              ></Button>
            ) : (
              ""
            )}
            {authentication_token && (
              <CustomButton
                onClick={() =>
                  window.open(
                    api.pathV6(
                      `/fleets.csv?page=${page}&auth_token=${authentication_token}&lancode=${
                        currentUser.language && currentUser.language.toUpperCase()
                      }&showInactiveFleets=${this.state.showInactiveFleets}`
                    )
                  )
                }
                className={isFleetAdvise() || isMobilease() ? "btn-margin-right" : ""}
                disabled={fleets && fleets.length === 0}
                iconSrc={DownloadIcon}
                iconClassName="vehicle-icons"
                label={t("downloadLabel")}
              />
            )}
          </Container>
          <FleetList
            fleets={fleets}
            language={currentUser.language}
            dispatch={dispatch}
            fleetsLoading={fleetsLoading}
            handlePage={this.handlePage}
            totalFleetCount={totalFleetCount}
            showInactiveFleets={this.state.showInactiveFleets}
            onCheckboxChange={this.handleCheckboxChange}
          />
        </div>
      )
    }
  }

  render() {
    const { isLoading, isLoadingError } = this.props

    const { alertMessage, alertType } = this.state
    const { found } = checkSubDomain()

    return (
      <ApplicationLayout>
        {alertMessage && (
          <Alert
            message={alertMessage}
            type={alertType}
            clearStateAfterTimeout={() =>
              clearStateAfterTimeout(this.setState.bind(this), ALERT_MESSAGE)
            }
          />
        )}

        <LoadingError visible={!isLoading && isLoadingError} />

        {this.renderContent()}
        {found && <DownloadAppModal />}
      </ApplicationLayout>
    )
  }
} // class Dashboard

const mapStateToProps = (state) => ({
  fleets: state.fleets.fleets,
  fleetsLoading: state.fleets.fleetsLoading,
  isLoading: state.application.isLoading,
  isLoadingError: state.application.isLoadingError,
  currentUser: state.application.userSessionData || state.users.currentUser,
  totalFleetCount: state.fleets.totalFleetCount
})

export default connect(mapStateToProps)(withTranslation("fmcDashboard")(FMCDashboard))
